import React, { Component } from 'react';
import { localize } from 'react-localize-redux';

import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';

import { Field } from 'redux-form';
import MenuItem from '@material-ui/core/MenuItem';
import ReactPhoneInput from 'helpers/reduxFormMaterialUiNext/ReactPhoneInput';

import * as validator from 'helpers/Validator';
import { featureEnabled } from 'helpers/ToggleBot';
import { getTranslatedString } from 'helpers/i18n';

class EmergencyContactForm extends Component {
  render() {
    const handleSubmit = this.props.handleSubmit;

    const style = {
      row: {
        padding: '0 15px',
        marginTop: '30px',
      },
      text_field_header: {
        padding: '0px',
        marginTop: '30px',
        textAlign: 'center',
      },
      text_field: {
        fontSize: '14px',
        marginTop: '15px',
      },
      select_field: {
        fontSize: '14px',
        marginTop: '15px',
      },
    };

    return (
      <form onSubmit={handleSubmit}>
        <div className="row" style={style.text_field_header}>
          <div className="row">
            <label style={{ width: '100%' }} aria-label={getTranslatedString('fullName')}>
              <Field
                name="full_name"
                component={TextField}
                label={getTranslatedString('fullName')}
                validate={[validator.required, validator.fullName]}
                style={style.text_field}
                variant="outlined"
                autoFocus
              />
            </label>
          </div>
          <div className="row">
            <label style={{ width: '100%' }} aria-label={getTranslatedString('email')}>
              <Field
                name="email"
                type="email"
                component={TextField}
                label={getTranslatedString('email')}
                style={style.text_field}
                validate={[validator.validEmail]}
                variant="outlined"
              />
            </label>
          </div>
          <div className="row">
            <label style={{ width: '100%' }} aria-label={getTranslatedString('phoneNumber')}>
              <Field
                name="phone_number"
                label={this.props.translate('phoneNumber')}
                component={ReactPhoneInput}
                validate={[validator.required, validator.validInternationalPhoneNumber]}
                style={style.text_field}
              />
            </label>
          </div>
          <div className="row">
            <label style={{ width: '100%' }} aria-label={getTranslatedString('relationship')}>
              {featureEnabled('ui.yardi_emergency_contacts_page.relationships') ? (
                <Field
                  name="relationship"
                  component={OutlinedSelect}
                  label={getTranslatedString('relationship')}
                  validate={[validator.required]}
                  style={style.select_field}
                  variant="outlined"
                >
                  <MenuItem value={'Daughter'}>
                    {getTranslatedString(
                      'landlordPortal.emergencyContactsYardiRelationships.daughter'
                    )}
                  </MenuItem>
                  <MenuItem value={'Friend'}>
                    {getTranslatedString(
                      'landlordPortal.emergencyContactsYardiRelationships.friend'
                    )}
                  </MenuItem>
                  <MenuItem value={'Husband'}>
                    {getTranslatedString(
                      'landlordPortal.emergencyContactsYardiRelationships.husband'
                    )}
                  </MenuItem>
                  <MenuItem value={'Son'}>
                    {getTranslatedString('landlordPortal.emergencyContactsYardiRelationships.son')}
                  </MenuItem>
                  <MenuItem value={'Wife'}>
                    {getTranslatedString('landlordPortal.emergencyContactsYardiRelationships.wife')}
                  </MenuItem>
                  <MenuItem value={'Other'}>
                    {getTranslatedString(
                      'landlordPortal.emergencyContactsYardiRelationships.other'
                    )}
                  </MenuItem>
                </Field>
              ) : (
                <Field
                  name="relationship"
                  component={OutlinedSelect}
                  label={getTranslatedString('relationship')}
                  validate={[validator.required]}
                  style={style.select_field}
                  variant="outlined"
                >
                  <MenuItem value="Family">{getTranslatedString('relationship.family')}</MenuItem>
                  <MenuItem value="Friend"> {getTranslatedString('relationship.friend')}</MenuItem>
                  <MenuItem value="Significant Other">
                    {getTranslatedString('relationship.significantOther')}
                  </MenuItem>
                  <MenuItem value="Work Associate">
                    {getTranslatedString('relationship.workAssociate')}
                  </MenuItem>
                </Field>
              )}
            </label>
          </div>
        </div>
      </form>
    );
  }
}

export default localize()(EmergencyContactForm);
